import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { showProfileVerifyingConfirm } from "@/lib/ageVerificationPurchaseGuard";

export default function useAgeVerifiedOnly<T extends (...args: any) => any>(
  cb: T
): (...args: Parameters<T>) => ReturnType<T> {
  const { authUser } = useAuthUser();
  return (...args) => {
    const ageVerificationStatus = authUser.value?.ageVerification?.status;
    if (ageVerificationStatus === UserVerificationStatus.WAITING_FOR_APPROVAL) {
      showProfileVerifyingConfirm("content");
      return;
    }
    // eslint-disable-next-line prefer-spread
    return cb.apply(undefined, args);
  };
}
